import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { Capabilities, useCapabilities } from '@/providers/useCapabilities';

// Defense-in-depth route guard. Route config objects can't call hooks, so this thin
// wrapper (used as a route `element`) reads useCapabilities() and only renders its
// children when the named boolean capability is granted; otherwise it redirects to the
// app root. Mirrors the existing `if (!canX) return <Navigate to="/" />` page guards
// (see PVForm / CRCForm) at the route level.
type RequireCapabilityProps = {
  capability: keyof Capabilities;
  children: ReactNode;
};

export const RequireCapability = ({ capability, children }: RequireCapabilityProps) => {
  const capabilities = useCapabilities();

  if (!capabilities[capability]) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
